export class Brod2PackagingTypeValueConverter {
  static x = {
    CAN: 'Boks',
    GLASS: 'Glass',
    KEG: 'Fat',
    PET_BOTTLE: 'PET-flaske',
    DISPENSER: 'Dispenser'
  };

  toView(value) {
    return Brod2PackagingTypeValueConverter.toView(value);
  }

  static toView(value) {
    return this.x[value];
  }
}
